import { createContext, useContext, useState } from 'react'

const PageDataContext = createContext()

export function PageDataProvider({ children }) {
  const [pageData, setPageData] = useState(null)

  return (
    <PageDataContext.Provider value={{ pageData, setPageData }}>
      {children}
    </PageDataContext.Provider>
  )
}

export function usePageData() {
  const context = useContext(PageDataContext)
  if (!context) {
    throw new Error('usePageData must be used within a PageDataProvider')
  }
  return context
}
